module.exports = __webpack_public_path__ + "img/festival_dragonboatfestival.1501a8d2.png";